var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"burger",attrs:{"id":"top-menu"},on:{"click":function($event){return _vm.clickHandler($event)}}},[_c('icon',{staticClass:"burger__icon",attrs:{"icon-name":"ic_menu","width":"24","height":"24"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }